// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Callpage.css
// module id = 1159
// module chunks = 0